import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  _Char___init__impl__6a9atx2gndcvjvc5pke as _Char___init__impl__6a9atx,
  Char__toInt_impl_vasixdnyockrdnmht5 as Char__toInt_impl_vasixd,
} from '../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { charArrayOf27f4r3dozbrk1 as charArrayOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_HEX_DIGIT_CHARS() {
  _init_properties_ByteString_kt__sqjq7b();
  return HEX_DIGIT_CHARS;
}
var HEX_DIGIT_CHARS;
function commonWrite(_this__u8e3s4, buffer, offset, byteCount) {
  _init_properties_ByteString_kt__sqjq7b();
  buffer.a3y(_this__u8e3s4.m3w_1, offset, byteCount);
}
function codePointIndexToCharIndex(s, codePointCount) {
  _init_properties_ByteString_kt__sqjq7b();
  var charCount = 0;
  var j = 0;
  // Inline function 'okio.processUtf8CodePoints' call
  var endIndex = s.length;
  var index = 0;
  while (index < endIndex) {
    var b0 = s[index];
    if (b0 >= 0) {
      var _unary__edvuaz = j;
      j = _unary__edvuaz + 1 | 0;
      if (_unary__edvuaz === codePointCount) {
        return charCount;
      }
      var tmp;
      var tmp_0;
      var tmp_1;
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(10);
      if (!(b0 === Char__toInt_impl_vasixd(this_0))) {
        // Inline function 'kotlin.code' call
        var this_1 = _Char___init__impl__6a9atx(13);
        tmp_1 = !(b0 === Char__toInt_impl_vasixd(this_1));
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        // Inline function 'okio.isIsoControl' call
        tmp_0 = (0 <= b0 ? b0 <= 31 : false) || (127 <= b0 ? b0 <= 159 : false);
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp = true;
      } else {
        tmp = b0 === 65533;
      }
      if (tmp) {
        return -1;
      }
      charCount = charCount + (b0 < 65536 ? 1 : 2) | 0;
      index = index + 1 | 0;
      while (index < endIndex && s[index] >= 0) {
        var _unary__edvuaz_0 = index;
        index = _unary__edvuaz_0 + 1 | 0;
        var c = s[_unary__edvuaz_0];
        var _unary__edvuaz_1 = j;
        j = _unary__edvuaz_1 + 1 | 0;
        if (_unary__edvuaz_1 === codePointCount) {
          return charCount;
        }
        var tmp_2;
        var tmp_3;
        var tmp_4;
        // Inline function 'kotlin.code' call
        var this_2 = _Char___init__impl__6a9atx(10);
        if (!(c === Char__toInt_impl_vasixd(this_2))) {
          // Inline function 'kotlin.code' call
          var this_3 = _Char___init__impl__6a9atx(13);
          tmp_4 = !(c === Char__toInt_impl_vasixd(this_3));
        } else {
          tmp_4 = false;
        }
        if (tmp_4) {
          // Inline function 'okio.isIsoControl' call
          tmp_3 = (0 <= c ? c <= 31 : false) || (127 <= c ? c <= 159 : false);
        } else {
          tmp_3 = false;
        }
        if (tmp_3) {
          tmp_2 = true;
        } else {
          tmp_2 = c === 65533;
        }
        if (tmp_2) {
          return -1;
        }
        charCount = charCount + (c < 65536 ? 1 : 2) | 0;
      }
    } else {
      // Inline function 'okio.shr' call
      if (b0 >> 5 === -2) {
        var tmp_5 = index;
        var tmp2 = index;
        var tmp$ret$10;
        $l$block_0: {
          // Inline function 'okio.process2Utf8Bytes' call
          if (endIndex <= (tmp2 + 1 | 0)) {
            var _unary__edvuaz_2 = j;
            j = _unary__edvuaz_2 + 1 | 0;
            if (_unary__edvuaz_2 === codePointCount) {
              return charCount;
            }
            var tmp_6;
            var tmp_7;
            var tmp_8;
            // Inline function 'kotlin.code' call
            var this_4 = _Char___init__impl__6a9atx(10);
            if (!(65533 === Char__toInt_impl_vasixd(this_4))) {
              // Inline function 'kotlin.code' call
              var this_5 = _Char___init__impl__6a9atx(13);
              tmp_8 = !(65533 === Char__toInt_impl_vasixd(this_5));
            } else {
              tmp_8 = false;
            }
            if (tmp_8) {
              // Inline function 'okio.isIsoControl' call
              tmp_7 = (0 <= 65533 ? 65533 <= 31 : false) || (127 <= 65533 ? 65533 <= 159 : false);
            } else {
              tmp_7 = false;
            }
            if (tmp_7) {
              tmp_6 = true;
            } else {
              tmp_6 = 65533 === 65533;
            }
            if (tmp_6) {
              return -1;
            }
            charCount = charCount + (65533 < 65536 ? 1 : 2) | 0;
            tmp$ret$10 = 1;
            break $l$block_0;
          }
          var b0_0 = s[tmp2];
          var b1 = s[tmp2 + 1 | 0];
          // Inline function 'okio.isUtf8Continuation' call
          // Inline function 'okio.and' call
          if (!((b1 & 192) === 128)) {
            var _unary__edvuaz_3 = j;
            j = _unary__edvuaz_3 + 1 | 0;
            if (_unary__edvuaz_3 === codePointCount) {
              return charCount;
            }
            var tmp_9;
            var tmp_10;
            var tmp_11;
            // Inline function 'kotlin.code' call
            var this_6 = _Char___init__impl__6a9atx(10);
            if (!(65533 === Char__toInt_impl_vasixd(this_6))) {
              // Inline function 'kotlin.code' call
              var this_7 = _Char___init__impl__6a9atx(13);
              tmp_11 = !(65533 === Char__toInt_impl_vasixd(this_7));
            } else {
              tmp_11 = false;
            }
            if (tmp_11) {
              // Inline function 'okio.isIsoControl' call
              tmp_10 = (0 <= 65533 ? 65533 <= 31 : false) || (127 <= 65533 ? 65533 <= 159 : false);
            } else {
              tmp_10 = false;
            }
            if (tmp_10) {
              tmp_9 = true;
            } else {
              tmp_9 = 65533 === 65533;
            }
            if (tmp_9) {
              return -1;
            }
            charCount = charCount + (65533 < 65536 ? 1 : 2) | 0;
            tmp$ret$10 = 1;
            break $l$block_0;
          }
          var codePoint = 3968 ^ b1 ^ b0_0 << 6;
          if (codePoint < 128) {
            var _unary__edvuaz_4 = j;
            j = _unary__edvuaz_4 + 1 | 0;
            if (_unary__edvuaz_4 === codePointCount) {
              return charCount;
            }
            var tmp_12;
            var tmp_13;
            var tmp_14;
            // Inline function 'kotlin.code' call
            var this_8 = _Char___init__impl__6a9atx(10);
            if (!(65533 === Char__toInt_impl_vasixd(this_8))) {
              // Inline function 'kotlin.code' call
              var this_9 = _Char___init__impl__6a9atx(13);
              tmp_14 = !(65533 === Char__toInt_impl_vasixd(this_9));
            } else {
              tmp_14 = false;
            }
            if (tmp_14) {
              // Inline function 'okio.isIsoControl' call
              tmp_13 = (0 <= 65533 ? 65533 <= 31 : false) || (127 <= 65533 ? 65533 <= 159 : false);
            } else {
              tmp_13 = false;
            }
            if (tmp_13) {
              tmp_12 = true;
            } else {
              tmp_12 = 65533 === 65533;
            }
            if (tmp_12) {
              return -1;
            }
            charCount = charCount + (65533 < 65536 ? 1 : 2) | 0;
          } else {
            var _unary__edvuaz_5 = j;
            j = _unary__edvuaz_5 + 1 | 0;
            if (_unary__edvuaz_5 === codePointCount) {
              return charCount;
            }
            var tmp_15;
            var tmp_16;
            var tmp_17;
            // Inline function 'kotlin.code' call
            var this_10 = _Char___init__impl__6a9atx(10);
            if (!(codePoint === Char__toInt_impl_vasixd(this_10))) {
              // Inline function 'kotlin.code' call
              var this_11 = _Char___init__impl__6a9atx(13);
              tmp_17 = !(codePoint === Char__toInt_impl_vasixd(this_11));
            } else {
              tmp_17 = false;
            }
            if (tmp_17) {
              // Inline function 'okio.isIsoControl' call
              tmp_16 = (0 <= codePoint ? codePoint <= 31 : false) || (127 <= codePoint ? codePoint <= 159 : false);
            } else {
              tmp_16 = false;
            }
            if (tmp_16) {
              tmp_15 = true;
            } else {
              tmp_15 = codePoint === 65533;
            }
            if (tmp_15) {
              return -1;
            }
            charCount = charCount + (codePoint < 65536 ? 1 : 2) | 0;
          }
          tmp$ret$10 = 2;
        }
        index = tmp_5 + tmp$ret$10 | 0;
      } else {
        // Inline function 'okio.shr' call
        if (b0 >> 4 === -2) {
          var tmp_18 = index;
          var tmp2_0 = index;
          var tmp$ret$34;
          $l$block_4: {
            // Inline function 'okio.process3Utf8Bytes' call
            if (endIndex <= (tmp2_0 + 2 | 0)) {
              var _unary__edvuaz_6 = j;
              j = _unary__edvuaz_6 + 1 | 0;
              if (_unary__edvuaz_6 === codePointCount) {
                return charCount;
              }
              var tmp_19;
              var tmp_20;
              var tmp_21;
              // Inline function 'kotlin.code' call
              var this_12 = _Char___init__impl__6a9atx(10);
              if (!(65533 === Char__toInt_impl_vasixd(this_12))) {
                // Inline function 'kotlin.code' call
                var this_13 = _Char___init__impl__6a9atx(13);
                tmp_21 = !(65533 === Char__toInt_impl_vasixd(this_13));
              } else {
                tmp_21 = false;
              }
              if (tmp_21) {
                // Inline function 'okio.isIsoControl' call
                tmp_20 = (0 <= 65533 ? 65533 <= 31 : false) || (127 <= 65533 ? 65533 <= 159 : false);
              } else {
                tmp_20 = false;
              }
              if (tmp_20) {
                tmp_19 = true;
              } else {
                tmp_19 = 65533 === 65533;
              }
              if (tmp_19) {
                return -1;
              }
              charCount = charCount + (65533 < 65536 ? 1 : 2) | 0;
              var tmp_22;
              if (endIndex <= (tmp2_0 + 1 | 0)) {
                tmp_22 = true;
              } else {
                // Inline function 'okio.isUtf8Continuation' call
                // Inline function 'okio.and' call
                tmp_22 = !((s[tmp2_0 + 1 | 0] & 192) === 128);
              }
              if (tmp_22) {
                tmp$ret$34 = 1;
                break $l$block_4;
              } else {
                tmp$ret$34 = 2;
                break $l$block_4;
              }
            }
            var b0_1 = s[tmp2_0];
            var b1_0 = s[tmp2_0 + 1 | 0];
            // Inline function 'okio.isUtf8Continuation' call
            // Inline function 'okio.and' call
            if (!((b1_0 & 192) === 128)) {
              var _unary__edvuaz_7 = j;
              j = _unary__edvuaz_7 + 1 | 0;
              if (_unary__edvuaz_7 === codePointCount) {
                return charCount;
              }
              var tmp_23;
              var tmp_24;
              var tmp_25;
              // Inline function 'kotlin.code' call
              var this_14 = _Char___init__impl__6a9atx(10);
              if (!(65533 === Char__toInt_impl_vasixd(this_14))) {
                // Inline function 'kotlin.code' call
                var this_15 = _Char___init__impl__6a9atx(13);
                tmp_25 = !(65533 === Char__toInt_impl_vasixd(this_15));
              } else {
                tmp_25 = false;
              }
              if (tmp_25) {
                // Inline function 'okio.isIsoControl' call
                tmp_24 = (0 <= 65533 ? 65533 <= 31 : false) || (127 <= 65533 ? 65533 <= 159 : false);
              } else {
                tmp_24 = false;
              }
              if (tmp_24) {
                tmp_23 = true;
              } else {
                tmp_23 = 65533 === 65533;
              }
              if (tmp_23) {
                return -1;
              }
              charCount = charCount + (65533 < 65536 ? 1 : 2) | 0;
              tmp$ret$34 = 1;
              break $l$block_4;
            }
            var b2 = s[tmp2_0 + 2 | 0];
            // Inline function 'okio.isUtf8Continuation' call
            // Inline function 'okio.and' call
            if (!((b2 & 192) === 128)) {
              var _unary__edvuaz_8 = j;
              j = _unary__edvuaz_8 + 1 | 0;
              if (_unary__edvuaz_8 === codePointCount) {
                return charCount;
              }
              var tmp_26;
              var tmp_27;
              var tmp_28;
              // Inline function 'kotlin.code' call
              var this_16 = _Char___init__impl__6a9atx(10);
              if (!(65533 === Char__toInt_impl_vasixd(this_16))) {
                // Inline function 'kotlin.code' call
                var this_17 = _Char___init__impl__6a9atx(13);
                tmp_28 = !(65533 === Char__toInt_impl_vasixd(this_17));
              } else {
                tmp_28 = false;
              }
              if (tmp_28) {
                // Inline function 'okio.isIsoControl' call
                tmp_27 = (0 <= 65533 ? 65533 <= 31 : false) || (127 <= 65533 ? 65533 <= 159 : false);
              } else {
                tmp_27 = false;
              }
              if (tmp_27) {
                tmp_26 = true;
              } else {
                tmp_26 = 65533 === 65533;
              }
              if (tmp_26) {
                return -1;
              }
              charCount = charCount + (65533 < 65536 ? 1 : 2) | 0;
              tmp$ret$34 = 2;
              break $l$block_4;
            }
            var codePoint_0 = -123008 ^ b2 ^ b1_0 << 6 ^ b0_1 << 12;
            if (codePoint_0 < 2048) {
              var _unary__edvuaz_9 = j;
              j = _unary__edvuaz_9 + 1 | 0;
              if (_unary__edvuaz_9 === codePointCount) {
                return charCount;
              }
              var tmp_29;
              var tmp_30;
              var tmp_31;
              // Inline function 'kotlin.code' call
              var this_18 = _Char___init__impl__6a9atx(10);
              if (!(65533 === Char__toInt_impl_vasixd(this_18))) {
                // Inline function 'kotlin.code' call
                var this_19 = _Char___init__impl__6a9atx(13);
                tmp_31 = !(65533 === Char__toInt_impl_vasixd(this_19));
              } else {
                tmp_31 = false;
              }
              if (tmp_31) {
                // Inline function 'okio.isIsoControl' call
                tmp_30 = (0 <= 65533 ? 65533 <= 31 : false) || (127 <= 65533 ? 65533 <= 159 : false);
              } else {
                tmp_30 = false;
              }
              if (tmp_30) {
                tmp_29 = true;
              } else {
                tmp_29 = 65533 === 65533;
              }
              if (tmp_29) {
                return -1;
              }
              charCount = charCount + (65533 < 65536 ? 1 : 2) | 0;
            } else if (55296 <= codePoint_0 ? codePoint_0 <= 57343 : false) {
              var _unary__edvuaz_10 = j;
              j = _unary__edvuaz_10 + 1 | 0;
              if (_unary__edvuaz_10 === codePointCount) {
                return charCount;
              }
              var tmp_32;
              var tmp_33;
              var tmp_34;
              // Inline function 'kotlin.code' call
              var this_20 = _Char___init__impl__6a9atx(10);
              if (!(65533 === Char__toInt_impl_vasixd(this_20))) {
                // Inline function 'kotlin.code' call
                var this_21 = _Char___init__impl__6a9atx(13);
                tmp_34 = !(65533 === Char__toInt_impl_vasixd(this_21));
              } else {
                tmp_34 = false;
              }
              if (tmp_34) {
                // Inline function 'okio.isIsoControl' call
                tmp_33 = (0 <= 65533 ? 65533 <= 31 : false) || (127 <= 65533 ? 65533 <= 159 : false);
              } else {
                tmp_33 = false;
              }
              if (tmp_33) {
                tmp_32 = true;
              } else {
                tmp_32 = 65533 === 65533;
              }
              if (tmp_32) {
                return -1;
              }
              charCount = charCount + (65533 < 65536 ? 1 : 2) | 0;
            } else {
              var _unary__edvuaz_11 = j;
              j = _unary__edvuaz_11 + 1 | 0;
              if (_unary__edvuaz_11 === codePointCount) {
                return charCount;
              }
              var tmp_35;
              var tmp_36;
              var tmp_37;
              // Inline function 'kotlin.code' call
              var this_22 = _Char___init__impl__6a9atx(10);
              if (!(codePoint_0 === Char__toInt_impl_vasixd(this_22))) {
                // Inline function 'kotlin.code' call
                var this_23 = _Char___init__impl__6a9atx(13);
                tmp_37 = !(codePoint_0 === Char__toInt_impl_vasixd(this_23));
              } else {
                tmp_37 = false;
              }
              if (tmp_37) {
                // Inline function 'okio.isIsoControl' call
                tmp_36 = (0 <= codePoint_0 ? codePoint_0 <= 31 : false) || (127 <= codePoint_0 ? codePoint_0 <= 159 : false);
              } else {
                tmp_36 = false;
              }
              if (tmp_36) {
                tmp_35 = true;
              } else {
                tmp_35 = codePoint_0 === 65533;
              }
              if (tmp_35) {
                return -1;
              }
              charCount = charCount + (codePoint_0 < 65536 ? 1 : 2) | 0;
            }
            tmp$ret$34 = 3;
          }
          index = tmp_18 + tmp$ret$34 | 0;
        } else {
          // Inline function 'okio.shr' call
          if (b0 >> 3 === -2) {
            var tmp_38 = index;
            var tmp2_1 = index;
            var tmp$ret$72;
            $l$block_10: {
              // Inline function 'okio.process4Utf8Bytes' call
              if (endIndex <= (tmp2_1 + 3 | 0)) {
                var _unary__edvuaz_12 = j;
                j = _unary__edvuaz_12 + 1 | 0;
                if (_unary__edvuaz_12 === codePointCount) {
                  return charCount;
                }
                var tmp_39;
                var tmp_40;
                var tmp_41;
                // Inline function 'kotlin.code' call
                var this_24 = _Char___init__impl__6a9atx(10);
                if (!(65533 === Char__toInt_impl_vasixd(this_24))) {
                  // Inline function 'kotlin.code' call
                  var this_25 = _Char___init__impl__6a9atx(13);
                  tmp_41 = !(65533 === Char__toInt_impl_vasixd(this_25));
                } else {
                  tmp_41 = false;
                }
                if (tmp_41) {
                  // Inline function 'okio.isIsoControl' call
                  tmp_40 = (0 <= 65533 ? 65533 <= 31 : false) || (127 <= 65533 ? 65533 <= 159 : false);
                } else {
                  tmp_40 = false;
                }
                if (tmp_40) {
                  tmp_39 = true;
                } else {
                  tmp_39 = 65533 === 65533;
                }
                if (tmp_39) {
                  return -1;
                }
                charCount = charCount + (65533 < 65536 ? 1 : 2) | 0;
                var tmp_42;
                if (endIndex <= (tmp2_1 + 1 | 0)) {
                  tmp_42 = true;
                } else {
                  // Inline function 'okio.isUtf8Continuation' call
                  // Inline function 'okio.and' call
                  tmp_42 = !((s[tmp2_1 + 1 | 0] & 192) === 128);
                }
                if (tmp_42) {
                  tmp$ret$72 = 1;
                  break $l$block_10;
                } else {
                  var tmp_43;
                  if (endIndex <= (tmp2_1 + 2 | 0)) {
                    tmp_43 = true;
                  } else {
                    // Inline function 'okio.isUtf8Continuation' call
                    // Inline function 'okio.and' call
                    tmp_43 = !((s[tmp2_1 + 2 | 0] & 192) === 128);
                  }
                  if (tmp_43) {
                    tmp$ret$72 = 2;
                    break $l$block_10;
                  } else {
                    tmp$ret$72 = 3;
                    break $l$block_10;
                  }
                }
              }
              var b0_2 = s[tmp2_1];
              var b1_1 = s[tmp2_1 + 1 | 0];
              // Inline function 'okio.isUtf8Continuation' call
              // Inline function 'okio.and' call
              if (!((b1_1 & 192) === 128)) {
                var _unary__edvuaz_13 = j;
                j = _unary__edvuaz_13 + 1 | 0;
                if (_unary__edvuaz_13 === codePointCount) {
                  return charCount;
                }
                var tmp_44;
                var tmp_45;
                var tmp_46;
                // Inline function 'kotlin.code' call
                var this_26 = _Char___init__impl__6a9atx(10);
                if (!(65533 === Char__toInt_impl_vasixd(this_26))) {
                  // Inline function 'kotlin.code' call
                  var this_27 = _Char___init__impl__6a9atx(13);
                  tmp_46 = !(65533 === Char__toInt_impl_vasixd(this_27));
                } else {
                  tmp_46 = false;
                }
                if (tmp_46) {
                  // Inline function 'okio.isIsoControl' call
                  tmp_45 = (0 <= 65533 ? 65533 <= 31 : false) || (127 <= 65533 ? 65533 <= 159 : false);
                } else {
                  tmp_45 = false;
                }
                if (tmp_45) {
                  tmp_44 = true;
                } else {
                  tmp_44 = 65533 === 65533;
                }
                if (tmp_44) {
                  return -1;
                }
                charCount = charCount + (65533 < 65536 ? 1 : 2) | 0;
                tmp$ret$72 = 1;
                break $l$block_10;
              }
              var b2_0 = s[tmp2_1 + 2 | 0];
              // Inline function 'okio.isUtf8Continuation' call
              // Inline function 'okio.and' call
              if (!((b2_0 & 192) === 128)) {
                var _unary__edvuaz_14 = j;
                j = _unary__edvuaz_14 + 1 | 0;
                if (_unary__edvuaz_14 === codePointCount) {
                  return charCount;
                }
                var tmp_47;
                var tmp_48;
                var tmp_49;
                // Inline function 'kotlin.code' call
                var this_28 = _Char___init__impl__6a9atx(10);
                if (!(65533 === Char__toInt_impl_vasixd(this_28))) {
                  // Inline function 'kotlin.code' call
                  var this_29 = _Char___init__impl__6a9atx(13);
                  tmp_49 = !(65533 === Char__toInt_impl_vasixd(this_29));
                } else {
                  tmp_49 = false;
                }
                if (tmp_49) {
                  // Inline function 'okio.isIsoControl' call
                  tmp_48 = (0 <= 65533 ? 65533 <= 31 : false) || (127 <= 65533 ? 65533 <= 159 : false);
                } else {
                  tmp_48 = false;
                }
                if (tmp_48) {
                  tmp_47 = true;
                } else {
                  tmp_47 = 65533 === 65533;
                }
                if (tmp_47) {
                  return -1;
                }
                charCount = charCount + (65533 < 65536 ? 1 : 2) | 0;
                tmp$ret$72 = 2;
                break $l$block_10;
              }
              var b3 = s[tmp2_1 + 3 | 0];
              // Inline function 'okio.isUtf8Continuation' call
              // Inline function 'okio.and' call
              if (!((b3 & 192) === 128)) {
                var _unary__edvuaz_15 = j;
                j = _unary__edvuaz_15 + 1 | 0;
                if (_unary__edvuaz_15 === codePointCount) {
                  return charCount;
                }
                var tmp_50;
                var tmp_51;
                var tmp_52;
                // Inline function 'kotlin.code' call
                var this_30 = _Char___init__impl__6a9atx(10);
                if (!(65533 === Char__toInt_impl_vasixd(this_30))) {
                  // Inline function 'kotlin.code' call
                  var this_31 = _Char___init__impl__6a9atx(13);
                  tmp_52 = !(65533 === Char__toInt_impl_vasixd(this_31));
                } else {
                  tmp_52 = false;
                }
                if (tmp_52) {
                  // Inline function 'okio.isIsoControl' call
                  tmp_51 = (0 <= 65533 ? 65533 <= 31 : false) || (127 <= 65533 ? 65533 <= 159 : false);
                } else {
                  tmp_51 = false;
                }
                if (tmp_51) {
                  tmp_50 = true;
                } else {
                  tmp_50 = 65533 === 65533;
                }
                if (tmp_50) {
                  return -1;
                }
                charCount = charCount + (65533 < 65536 ? 1 : 2) | 0;
                tmp$ret$72 = 3;
                break $l$block_10;
              }
              var codePoint_1 = 3678080 ^ b3 ^ b2_0 << 6 ^ b1_1 << 12 ^ b0_2 << 18;
              if (codePoint_1 > 1114111) {
                var _unary__edvuaz_16 = j;
                j = _unary__edvuaz_16 + 1 | 0;
                if (_unary__edvuaz_16 === codePointCount) {
                  return charCount;
                }
                var tmp_53;
                var tmp_54;
                var tmp_55;
                // Inline function 'kotlin.code' call
                var this_32 = _Char___init__impl__6a9atx(10);
                if (!(65533 === Char__toInt_impl_vasixd(this_32))) {
                  // Inline function 'kotlin.code' call
                  var this_33 = _Char___init__impl__6a9atx(13);
                  tmp_55 = !(65533 === Char__toInt_impl_vasixd(this_33));
                } else {
                  tmp_55 = false;
                }
                if (tmp_55) {
                  // Inline function 'okio.isIsoControl' call
                  tmp_54 = (0 <= 65533 ? 65533 <= 31 : false) || (127 <= 65533 ? 65533 <= 159 : false);
                } else {
                  tmp_54 = false;
                }
                if (tmp_54) {
                  tmp_53 = true;
                } else {
                  tmp_53 = 65533 === 65533;
                }
                if (tmp_53) {
                  return -1;
                }
                charCount = charCount + (65533 < 65536 ? 1 : 2) | 0;
              } else if (55296 <= codePoint_1 ? codePoint_1 <= 57343 : false) {
                var _unary__edvuaz_17 = j;
                j = _unary__edvuaz_17 + 1 | 0;
                if (_unary__edvuaz_17 === codePointCount) {
                  return charCount;
                }
                var tmp_56;
                var tmp_57;
                var tmp_58;
                // Inline function 'kotlin.code' call
                var this_34 = _Char___init__impl__6a9atx(10);
                if (!(65533 === Char__toInt_impl_vasixd(this_34))) {
                  // Inline function 'kotlin.code' call
                  var this_35 = _Char___init__impl__6a9atx(13);
                  tmp_58 = !(65533 === Char__toInt_impl_vasixd(this_35));
                } else {
                  tmp_58 = false;
                }
                if (tmp_58) {
                  // Inline function 'okio.isIsoControl' call
                  tmp_57 = (0 <= 65533 ? 65533 <= 31 : false) || (127 <= 65533 ? 65533 <= 159 : false);
                } else {
                  tmp_57 = false;
                }
                if (tmp_57) {
                  tmp_56 = true;
                } else {
                  tmp_56 = 65533 === 65533;
                }
                if (tmp_56) {
                  return -1;
                }
                charCount = charCount + (65533 < 65536 ? 1 : 2) | 0;
              } else if (codePoint_1 < 65536) {
                var _unary__edvuaz_18 = j;
                j = _unary__edvuaz_18 + 1 | 0;
                if (_unary__edvuaz_18 === codePointCount) {
                  return charCount;
                }
                var tmp_59;
                var tmp_60;
                var tmp_61;
                // Inline function 'kotlin.code' call
                var this_36 = _Char___init__impl__6a9atx(10);
                if (!(65533 === Char__toInt_impl_vasixd(this_36))) {
                  // Inline function 'kotlin.code' call
                  var this_37 = _Char___init__impl__6a9atx(13);
                  tmp_61 = !(65533 === Char__toInt_impl_vasixd(this_37));
                } else {
                  tmp_61 = false;
                }
                if (tmp_61) {
                  // Inline function 'okio.isIsoControl' call
                  tmp_60 = (0 <= 65533 ? 65533 <= 31 : false) || (127 <= 65533 ? 65533 <= 159 : false);
                } else {
                  tmp_60 = false;
                }
                if (tmp_60) {
                  tmp_59 = true;
                } else {
                  tmp_59 = 65533 === 65533;
                }
                if (tmp_59) {
                  return -1;
                }
                charCount = charCount + (65533 < 65536 ? 1 : 2) | 0;
              } else {
                var _unary__edvuaz_19 = j;
                j = _unary__edvuaz_19 + 1 | 0;
                if (_unary__edvuaz_19 === codePointCount) {
                  return charCount;
                }
                var tmp_62;
                var tmp_63;
                var tmp_64;
                // Inline function 'kotlin.code' call
                var this_38 = _Char___init__impl__6a9atx(10);
                if (!(codePoint_1 === Char__toInt_impl_vasixd(this_38))) {
                  // Inline function 'kotlin.code' call
                  var this_39 = _Char___init__impl__6a9atx(13);
                  tmp_64 = !(codePoint_1 === Char__toInt_impl_vasixd(this_39));
                } else {
                  tmp_64 = false;
                }
                if (tmp_64) {
                  // Inline function 'okio.isIsoControl' call
                  tmp_63 = (0 <= codePoint_1 ? codePoint_1 <= 31 : false) || (127 <= codePoint_1 ? codePoint_1 <= 159 : false);
                } else {
                  tmp_63 = false;
                }
                if (tmp_63) {
                  tmp_62 = true;
                } else {
                  tmp_62 = codePoint_1 === 65533;
                }
                if (tmp_62) {
                  return -1;
                }
                charCount = charCount + (codePoint_1 < 65536 ? 1 : 2) | 0;
              }
              tmp$ret$72 = 4;
            }
            index = tmp_38 + tmp$ret$72 | 0;
          } else {
            var _unary__edvuaz_20 = j;
            j = _unary__edvuaz_20 + 1 | 0;
            if (_unary__edvuaz_20 === codePointCount) {
              return charCount;
            }
            var tmp_65;
            var tmp_66;
            var tmp_67;
            // Inline function 'kotlin.code' call
            var this_40 = _Char___init__impl__6a9atx(10);
            if (!(65533 === Char__toInt_impl_vasixd(this_40))) {
              // Inline function 'kotlin.code' call
              var this_41 = _Char___init__impl__6a9atx(13);
              tmp_67 = !(65533 === Char__toInt_impl_vasixd(this_41));
            } else {
              tmp_67 = false;
            }
            if (tmp_67) {
              // Inline function 'okio.isIsoControl' call
              tmp_66 = (0 <= 65533 ? 65533 <= 31 : false) || (127 <= 65533 ? 65533 <= 159 : false);
            } else {
              tmp_66 = false;
            }
            if (tmp_66) {
              tmp_65 = true;
            } else {
              tmp_65 = 65533 === 65533;
            }
            if (tmp_65) {
              return -1;
            }
            charCount = charCount + (65533 < 65536 ? 1 : 2) | 0;
            index = index + 1 | 0;
          }
        }
      }
    }
  }
  return charCount;
}
function access$codePointIndexToCharIndex$tByteStringKt(s, codePointCount) {
  return codePointIndexToCharIndex(s, codePointCount);
}
var properties_initialized_ByteString_kt_8ybv8b;
function _init_properties_ByteString_kt__sqjq7b() {
  if (!properties_initialized_ByteString_kt_8ybv8b) {
    properties_initialized_ByteString_kt_8ybv8b = true;
    // Inline function 'kotlin.charArrayOf' call
    HEX_DIGIT_CHARS = charArrayOf([_Char___init__impl__6a9atx(48), _Char___init__impl__6a9atx(49), _Char___init__impl__6a9atx(50), _Char___init__impl__6a9atx(51), _Char___init__impl__6a9atx(52), _Char___init__impl__6a9atx(53), _Char___init__impl__6a9atx(54), _Char___init__impl__6a9atx(55), _Char___init__impl__6a9atx(56), _Char___init__impl__6a9atx(57), _Char___init__impl__6a9atx(97), _Char___init__impl__6a9atx(98), _Char___init__impl__6a9atx(99), _Char___init__impl__6a9atx(100), _Char___init__impl__6a9atx(101), _Char___init__impl__6a9atx(102)]);
  }
}
//region block: exports
export {
  access$codePointIndexToCharIndex$tByteStringKt as access$codePointIndexToCharIndex$tByteStringKt2a2y38zo1jcm,
  get_HEX_DIGIT_CHARS as get_HEX_DIGIT_CHARSdv75g3vie5sw,
  commonWrite as commonWrite1hq6d430w9jqm,
};
//endregion

//# sourceMappingURL=ByteString.mjs.map
